<template>
  <div class="all">
    <div class="search1">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item><img style="width:100%;" src="../../assets/search1.jpg"/></van-swipe-item>
        <van-swipe-item><img style="width:100%;" src="../../assets/search2.jpg"/></van-swipe-item>
      </van-swipe>
    </div>
    <div class="menu">
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.2rem;">&#xe60d;</i>
          </div>
          <div class="context" @click="goto('/shop/yyjs')">
            <span class="title">预约祭扫</span><br />
            <span class="text">随时预约 专业服务</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.5rem;">&#xe636;</i>
          </div>
          <div class="context" @click="goto('/shop/glf')">
            <span class="title">缴纳维护费</span><br />
            <span class="text">方便快捷 在线搞定</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.5rem;">&#xe66e;</i>
          </div>
          <div class="context" @click="goto('/shop/gmdj')">
            <span class="title">购墓登记</span><br />
            <span class="text">随时预约 专业服务</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.5rem;">&#xe637;</i>
          </div>
          <div class="context" @click="goto('/shop/phzb')">
            <span class="title">盆花租摆</span><br />
            <span class="text">精美鲜花 专人定期管理</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.5rem;">&#xe76e;</i>
          </div>
          <div class="context" @click="goto('/jisao')">
            <span class="title">代客祭扫</span><br />
            <span class="text">时间再忙 也不耽误祭扫</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.5rem;">&#xe634;</i>
          </div>
          <div class="context" @click="goto('/shop/ydfw')">
            <span class="title">预订服务</span><br />
            <span class="text">专业服务 方便快捷</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.5rem;">&#xe624;</i>
          </div>
          <div class="context" @click="goto('/shop/zxbx')">
            <span class="title">在线报修</span><br />
            <span class="text">专业团队 立即修复不等待</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
      <ul>
        <li>
          <div class="pic">
            <i class="iconfont" style="font-size:2.5rem;">&#xe61f;</i>
          </div>
          <div class="context" @click="goto('/shop/coupon')">
            <span class="title">优惠券</span><br />
            <span class="text">便宜优惠 在线购买</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        </li>
      </ul>
    </div>
    <div class="clear-foot"></div>
  </div>
</template>

<script>
import bus from '../../common/bus'
export default {
  name: 'my',
  data() {
    return {}
  },
  created() {
    bus.$emit('menuClick', 1)
  },
  mounted() {
    bus.$emit('menuClick', 1)
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
  },
}
</script>

<style>
.all {
  height: 66.7rem;
  width: 100%;
}
.menu ul li {
  list-style: none;
  width: 100%;
  background-color: #fff;
  padding: 1.6rem 0 0 1.2rem;
  box-sizing: border-box;
  position: relative;
}
.menu ul li .jiantou {
  position: absolute;
  right: 1rem;
  top: 1.5rem;
  font-size: 1.5rem;
}
.menu ul li .pic {
  width: 3rem;
  text-align: center;
  padding-top: 0.5rem;
  position: relative;
  left: -0.6rem;
}
.menu ul li .pic i {
  font-size: 2rem;
}
.b8 {
  height: 2.277rem;
  width: 2rem;
}
.menu ul li .context {
  margin-top: -3.5rem;
  margin-left: 3rem;
  line-height: 1.8rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
  position: relative;
}
.menu ul li .title {
  font-size: 1.4rem;
}
.menu ul li .text {
  font-size: 1.2rem;
  color: #999;
}
.menu ul li .context:after {
  content: '';
  width: 0.8rem;
  height: 1.415rem;
  position: absolute;
  top: 1rem;
  right: 1.7rem;
  /* background: url(https://fushouyuan.oss-cn-shanghai.aliyuncs.com/images/usercenter/page1.svg); */
}
</style>
